import { BsFillLayersFill } from "react-icons/bs";
import { FaFolderOpen } from "react-icons/fa";
import { IoBarChartOutline, IoSettingsOutline } from "react-icons/io5";
import { BsRobot } from "react-icons/bs";
import { RiAccountPinBoxFill, RiMoneyDollarBoxLine, RiTeamLine } from "react-icons/ri";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { HiOutlineUsers } from "react-icons/hi2";
import { title } from "process";
import { LuCircleDollarSign } from "react-icons/lu";
import { PiFolderOpen, PiFolderOpenLight } from "react-icons/pi";
export const pageTitle = {
  "/chat": {
    title: "Multi-provider AI Chat",
    icon: null,
    className: "pageHeader",
  },
  "/chat/": {
    title: "Multi-provider AI Chat",
    icon: null,
    className: "pageHeader",

  },
  "/knowledge-base": {
    title: "Knowledge Base",
    icon: <PiFolderOpen />
  },
  "/config": {
    title: "Settings",
    icon: <IoSettingsOutline />
  },
  "/profile": {
    title: "Account Settings",
    icon: <RiAccountPinBoxFill  />
  },
  "/agentsList": {
    title: "Agents",
    icon: <BsRobot />
  },
  "/allAssistantsList": {
    title: "Agents",
    icon: <BsRobot />
  },
  "/users-agents": {
    title: "Agents",
    icon: <BsRobot />
  },
  "/public-agent" : {
    title: "Explore Agents",
    icon: <BsFillLayersFill />
  },
  "/users" : {
    title: "Users",
    icon:<HiOutlineUsers />
  },
  "/allUsers" : {
    title: "Users",
    icon:<HiOutlineUsers/>
  },
  "/teams" : {
    title: "Departments",
    icon:<RiTeamLine />
  },
  "/allTeams" : {
    title: "Departments",
    icon:<RiTeamLine />
  },
  "/trackUsage" : {
    title: "Usage",
    icon:<IoBarChartOutline />
  },
  "/trackUsageList" : {
    title: "Usage",
    icon:<IoBarChartOutline />
  },
  "/subscriptions" : {
    title: "Subscriptions",
    icon:<LuCircleDollarSign />
  },
  "/pricing" : {
    title: "Pricing",
    icon:<RiMoneyDollarBoxLine />
  }
};
